import React from "react";

export const DisplayRow = (props) => {
  const rowClasses = props.rowClasses || "";
  const colClasses = props.colClasses || "";

  return (
    <div className={`row-no-gutters ${rowClasses}`}>
      <div className={`col-12 content-space-between ${colClasses}`}>
        <div>{props.label}</div>
        <div>{props.value}</div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/utils/displayRow.component.js